/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { SlideShowView } from "components/document/page/SlideShowView";
import { SinglePageContainer } from "containers/document/SinglePageContainer";
import { pageContentHandler } from "pageContentHandler";
import { overlayEvents } from "overlays/OverlayEvents";
import { getViewPortHeight, getViewPortWidth } from "selectors/documentViewSelectors";
import { getCurrentPageIndex } from "selectors/pageNumber";
import { getMargin } from "selectors/zoom";
import { triggerPagesInViewEvent } from "publicApis/Events/events";
import { getTotalPages } from "selectors/documentSelectors";
import { getViewPortWidthWithoutPagesViewScrollbar } from "selectors/documentViewSelectors";

const mapStoreToProps = (stores, ownProps) => {
  const viewPortHeight = getViewPortHeight(stores);
  const viewPortWidth = getViewPortWidth(stores);
  return {
    PageContainer: SinglePageContainer,
    pageCount: getTotalPages(stores),
    currPageIndexForSlideMode: getCurrentPageIndex(stores),
    viewportWidth: getViewPortWidthWithoutPagesViewScrollbar(stores),
    setFocusMethod: ownProps.setFocusMethod,
    onPagesInViewChange: pagesInView => {
      stores.documentStore.loadPagesInView(pagesInView);
      triggerPagesInViewEvent(stores);
    },
    onMouseDown: evt => {
      pageContentHandler.handleMouseDownOnDocument(evt, stores);
    },
    onClick: evt => {
      overlayEvents.trigger("documentclick", evt);
    },
    parentViewHeight: viewPortHeight,
    setElementHandle: handle => {
      stores.pagedViewState.setPagesViewElementHandle(handle);
    },
    margins: getMargin(stores)
  };
};

const SlideShowContainer = inject(mapStoreToProps)(SlideShowView);

export { SlideShowContainer };
